import script from "./GreenScreenBar.vue?vue&type=script&setup=true&lang=js"
export * from "./GreenScreenBar.vue?vue&type=script&setup=true&lang=js"

import "./GreenScreenBar.vue?vue&type=style&index=0&id=6a432a09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a432a09"]])

export default __exports__